const messages = {
    en: {
        role: {
            permissions: {
                AGENCIAOBJETIVO_IMPORT: "Import agency objectives",
                AGENCIAOBJETIVO_DASHBOARD: "View agency objectives dashboard",
                AGENCIAOBJETIVO_ADMIN_DASHBOARD: "View all-agencies objectives dashboard",
            }
        }
    },
    es: {
        role: {
            permissions: {
                AGENCIAOBJETIVO_IMPORT: "Importar objetivos de agencia",
                AGENCIAOBJETIVO_DASHBOARD: "Ver dashboard de objetivos de agencia",
                AGENCIAOBJETIVO_ADMIN_DASHBOARD: "Ver dashboard de objetivos de todas las agencias",
            }
        }
    },
    pt: {
        role: {
            permissions: {
                AGENCIAOBJETIVO_IMPORT: "Importar objetivos de agencia",
                AGENCIAOBJETIVO_DASHBOARD: "Ver painel de objetivos de agencia",
                AGENCIAOBJETIVO_ADMIN_DASHBOARD: "Ver painel de objetivos de todas as agencias",
            }
        }
    }
}

export default messages
